import { rando } from '../../lib/rando-sidecar'
import { generate } from './project-name-generator/generator'

// const fakerator = require('fakerator/locales/default')()
const fakerator = require('fakerator')()

const namespace = 'fakes'
export function genFakeName() {
  let name = fakerator.names.name()
  // console.log(namespace, name)
  return name
}

const pets = [
  'rock',
  'book',
  'robot',
  'cat',
  'doggo',
  'frog',
  'lemon tree',
  'gila monster',
  'chicken',
  'rat',
]
const foods = [
  'pizza',
  'popcorn',
  'yogurt',
  'cheese',
  'kale',
  'sushi',
  'potato chips',
  'glue',
  'paste',
  'sausages',
]
export function genFakeLike() {
  let l = rando.sample(likes)
  // console.log(namespace, l)
  return l()
}

function genFakePet1() {
  return `Has a pet ${rando.sample(pets)}.`
}
function genFakePet2() {
  return `Keeps a ${rando.sample(pets)} as a pet.`
}
function genFaveFood1() {
  return `Likes to eat ${rando.sample(foods)}.`
}
function genFaveFood2() {
  return `Their favorite food is ${rando.sample(foods)}.`
}
const likes = [genFakePet1, genFakePet2, genFaveFood1, genFaveFood2]

export function genFakeProjectName() {
  return generate({ words: rando.i(2, 3) }).spaced
}

const titles = [
  'Captain',
  'Doctor',
  'Number One',
  'Intern',
  'Lawyer',
  'Game Developer',
  'Cook',
  'Gunner',
]

export function genFakeTitle() {
  if (titles.length > 0) {
    return titles.shift() || 'Redshirt'
  }
  return 'Redshirt'
}
